const postCompletionPreviewScenarios = [
  {
    name: 'tasker-first-verified-unlock',
    label: 'Tasker first verified unlock',
    playerBalance: 12450,
    context: {
      kind: 'task_completed',
      entityType: 'task',
      entityId: 'task-preview-001',
      title: 'Grocery run completed',
      role: 'tasker',
      counterpartyName: 'maria_owner',
      amountUSD: 18,
      amountJGK: 18000,
      localValueCreated: { amountUSD: 18, amountJGK: 18000 },
      actionCredit: {
        eligibleForViewer: true,
        awarded: true,
        duplicate: false,
        total: 1,
        trustLabel: 'Verified Local',
        trustUnlocked: true,
      },
      trust: { total: 1, label: 'Verified Local', unlocked: true },
      verifiedRecord: { added: true, duplicate: false },
      nextAction: { kind: 'landing_primary', label: 'Earn again' },
      secondaryAction: { kind: 'use_locally', label: 'Use JGK locally' },
      sharePayload: {
        entityType: 'task',
        entityId: 'task-preview-001',
        amountUSD: 18,
        amountJGK: 18000,
        status: 'task_completed',
      },
    },
  },
  {
    name: 'tasker-awarded-already-verified',
    label: 'Tasker awarded already verified',
    playerBalance: 56200,
    context: {
      kind: 'task_completed',
      entityType: 'task',
      entityId: 'task-preview-002',
      title: 'Mailbox pickup completed',
      role: 'tasker',
      counterpartyName: 'owner_verified',
      amountUSD: 9.5,
      amountJGK: 9500,
      localValueCreated: { amountUSD: 9.5, amountJGK: 9500 },
      actionCredit: {
        eligibleForViewer: true,
        awarded: true,
        duplicate: false,
        total: 7,
        trustLabel: 'Verified Local',
        trustUnlocked: false,
      },
      trust: { total: 7, label: 'Verified Local', unlocked: false },
      verifiedRecord: { added: true, duplicate: false },
      nextAction: { kind: 'landing_primary', label: 'Resume accepted task' },
      secondaryAction: { kind: 'use_locally', label: 'Use JGK locally' },
      sharePayload: {
        entityType: 'task',
        entityId: 'task-preview-002',
        amountUSD: 9.5,
        amountJGK: 9500,
        status: 'task_completed',
      },
    },
  },
  {
    name: 'tasker-duplicate-no-new-credit',
    label: 'Tasker duplicate no new Action Credit',
    playerBalance: 72400,
    context: {
      kind: 'task_completed',
      entityType: 'task',
      entityId: 'task-preview-003',
      title: 'Pet walk completed',
      role: 'tasker',
      counterpartyName: 'owner_repeat',
      amountUSD: 14,
      amountJGK: 14000,
      localValueCreated: { amountUSD: 14, amountJGK: 14000 },
      actionCredit: {
        eligibleForViewer: true,
        awarded: false,
        duplicate: true,
        total: 7,
        trustLabel: 'Verified Local',
        trustUnlocked: false,
      },
      trust: { total: 7, label: 'Verified Local', unlocked: false },
      verifiedRecord: { added: false, duplicate: true },
      nextAction: { kind: 'landing_primary', label: 'Find another task' },
      secondaryAction: { kind: 'use_locally', label: 'Use JGK locally' },
      sharePayload: {
        entityType: 'task',
        entityId: 'task-preview-003',
        amountUSD: 14,
        amountJGK: 14000,
        status: 'task_completed',
      },
    },
  },
  {
    name: 'creator-completion-no-viewer-credit',
    label: 'Creator sees completion no viewer credit',
    playerBalance: 23100,
    context: {
      kind: 'task_completed',
      entityType: 'task',
      entityId: 'task-preview-004',
      title: 'Task completed by local worker',
      role: 'creator',
      counterpartyName: 'trusted_runner',
      amountUSD: 22,
      amountJGK: 22000,
      localValueCreated: { amountUSD: 22, amountJGK: 22000 },
      actionCredit: {
        eligibleForViewer: false,
        awarded: false,
        duplicate: false,
        total: 4,
        trustLabel: 'Verified Local',
        trustUnlocked: false,
      },
      trust: { total: 4, label: 'Verified Local', unlocked: false },
      verifiedRecord: { added: false, duplicate: false },
      nextAction: { kind: 'landing_primary', label: 'Create another task' },
      secondaryAction: { kind: 'use_locally', label: 'Use JGK locally' },
      sharePayload: {
        entityType: 'task',
        entityId: 'task-preview-004',
        amountUSD: 22,
        amountJGK: 22000,
        status: 'task_completed',
      },
    },
  },
  {
    name: 'offering-fulfillment-seller-no-credit',
    label: 'Offering fulfillment seller view',
    playerBalance: 30840,
    context: {
      kind: 'offering_fulfilled',
      entityType: 'offering',
      entityId: 'offering-preview-005',
      title: 'Offering fulfilled',
      role: 'creator',
      counterpartyName: 'buyer_local',
      amountUSD: 42,
      amountJGK: 42000,
      localValueCreated: { amountUSD: 42, amountJGK: 42000 },
      actionCredit: {
        eligibleForViewer: false,
        awarded: false,
        duplicate: false,
        total: 8,
        trustLabel: 'Verified Local',
        trustUnlocked: false,
      },
      trust: { total: 8, label: 'Verified Local', unlocked: false },
      verifiedRecord: { added: false, duplicate: false },
      nextAction: { kind: 'landing_primary', label: 'Post another offering' },
      secondaryAction: { kind: 'use_locally', label: 'Use JGK locally' },
      sharePayload: {
        entityType: 'offering',
        entityId: 'offering-preview-005',
        amountUSD: 42,
        amountJGK: 42000,
        status: 'offering_fulfilled',
      },
    },
  },
  {
    name: 'offering-fulfillment-buyer-earned-credit',
    label: 'Offering fulfillment buyer earns credit',
    playerBalance: 9170,
    context: {
      kind: 'offering_fulfilled',
      entityType: 'offering',
      entityId: 'offering-preview-006',
      title: 'Order complete',
      role: 'buyer',
      counterpartyName: 'shopkeeper_jg',
      amountUSD: 11.75,
      amountJGK: 11750,
      localValueCreated: { amountUSD: 11.75, amountJGK: 11750 },
      actionCredit: {
        eligibleForViewer: true,
        awarded: true,
        duplicate: false,
        total: 2,
        trustLabel: 'Verified Local',
        trustUnlocked: true,
      },
      trust: { total: 2, label: 'Verified Local', unlocked: true },
      verifiedRecord: { added: true, duplicate: false },
      nextAction: { kind: 'landing_primary', label: 'Use JGK locally again' },
      secondaryAction: { kind: 'use_locally', label: 'Find nearby offers' },
      sharePayload: {
        entityType: 'offering',
        entityId: 'offering-preview-006',
        amountUSD: 11.75,
        amountJGK: 11750,
        status: 'offering_fulfilled',
      },
    },
  },
  {
    name: 'low-zero-reward-edge',
    label: 'Low or zero reward edge case',
    playerBalance: 0,
    context: {
      kind: 'task_completed',
      entityType: 'task',
      entityId: 'task-preview-007',
      title: 'Volunteer verification complete',
      role: 'creator',
      counterpartyName: 'helper_zero',
      amountUSD: 0,
      amountJGK: 0,
      localValueCreated: { amountUSD: 0, amountJGK: 0 },
      actionCredit: {
        eligibleForViewer: false,
        awarded: false,
        duplicate: false,
        total: 0,
        trustLabel: null,
        trustUnlocked: false,
      },
      trust: { total: 0, label: null, unlocked: false },
      verifiedRecord: { added: false, duplicate: false },
      nextAction: { kind: 'landing_primary', label: 'Create another task' },
      secondaryAction: { kind: 'use_locally', label: 'Use JGK locally' },
      sharePayload: {
        entityType: 'task',
        entityId: 'task-preview-007',
        amountUSD: 0,
        amountJGK: 0,
        status: 'task_completed',
      },
    },
  },
  {
    name: 'long-copy-stress',
    label: 'Long copy stress',
    playerBalance: 144500,
    context: {
      kind: 'task_completed',
      entityType: 'task',
      entityId: 'task-preview-008',
      title:
        'Emergency same-day grocery + pharmacy + package return run completed with all checklist items verified',
      role: 'tasker',
      counterpartyName:
        'counterparty_with_an_unusually_long_display_name_for_copy_stress_testing',
      amountUSD: 123.45,
      amountJGK: 123450,
      localValueCreated: { amountUSD: 123.45, amountJGK: 123450 },
      actionCredit: {
        eligibleForViewer: true,
        awarded: false,
        duplicate: true,
        total: 23,
        trustLabel: 'Verified Local',
        trustUnlocked: false,
      },
      trust: { total: 23, label: 'Verified Local', unlocked: false },
      verifiedRecord: { added: false, duplicate: true },
      nextAction: {
        kind: 'landing_primary',
        label: 'Continue earning with nearby high-value LocalOps opportunities',
      },
      secondaryAction: {
        kind: 'use_locally',
        label: 'Review nearby trusted places that accept JGK now',
      },
      sharePayload: {
        entityType: 'task',
        entityId: 'task-preview-008',
        amountUSD: 123.45,
        amountJGK: 123450,
        status: 'task_completed',
      },
    },
  },
  {
    name: 'mobile-narrow',
    label: 'Mobile narrow stress',
    playerBalance: 14320,
    context: {
      kind: 'task_completed',
      entityType: 'task',
      entityId: 'task-preview-009',
      title: 'Doorstep handoff complete',
      role: 'tasker',
      counterpartyName: 'local_host',
      amountUSD: 6.25,
      amountJGK: 6250,
      localValueCreated: { amountUSD: 6.25, amountJGK: 6250 },
      actionCredit: {
        eligibleForViewer: true,
        awarded: true,
        duplicate: false,
        total: 5,
        trustLabel: 'Verified Local',
        trustUnlocked: false,
      },
      trust: { total: 5, label: 'Verified Local', unlocked: false },
      verifiedRecord: { added: true, duplicate: false },
      nextAction: { kind: 'landing_primary', label: 'Resume accepted task' },
      secondaryAction: { kind: 'use_locally', label: 'Use JGK locally' },
      sharePayload: {
        entityType: 'task',
        entityId: 'task-preview-009',
        amountUSD: 6.25,
        amountJGK: 6250,
        status: 'task_completed',
      },
    },
  },
  {
    name: 'long-counterparty-stress',
    label: 'Long counterparty stress',
    playerBalance: 50880,
    context: {
      kind: 'offering_fulfilled',
      entityType: 'offering',
      entityId: 'offering-preview-010',
      title: 'Order fulfilled and verified',
      role: 'creator',
      counterpartyName:
        'counterparty_with_extraordinarily_long_verification_identity_for_layout_stability_testing',
      amountUSD: 19,
      amountJGK: 19000,
      localValueCreated: { amountUSD: 19, amountJGK: 19000 },
      actionCredit: {
        eligibleForViewer: false,
        awarded: false,
        duplicate: false,
        total: 9,
        trustLabel: 'Verified Local',
        trustUnlocked: false,
      },
      trust: { total: 9, label: 'Verified Local', unlocked: false },
      verifiedRecord: { added: false, duplicate: false },
      nextAction: { kind: 'landing_primary', label: 'Post another offering' },
      secondaryAction: {
        kind: 'use_locally',
        label: 'Review nearby trusted places that accept JGK now',
      },
      sharePayload: {
        entityType: 'offering',
        entityId: 'offering-preview-010',
        amountUSD: 19,
        amountJGK: 19000,
        status: 'offering_fulfilled',
      },
    },
  },
  {
    name: 'next-action-unavailable',
    label: 'Next action fallback stress',
    playerBalance: 0,
    context: {
      kind: 'task_completed',
      entityType: 'task',
      entityId: 'task-preview-011',
      title: 'Verification check complete',
      role: 'creator',
      counterpartyName: 'neighbor_helper',
      amountUSD: 0,
      amountJGK: 0,
      localValueCreated: { amountUSD: 0, amountJGK: 0 },
      actionCredit: {
        eligibleForViewer: false,
        awarded: false,
        duplicate: false,
        total: 2,
        trustLabel: 'Verified Local',
        trustUnlocked: false,
      },
      trust: { total: 2, label: 'Verified Local', unlocked: false },
      verifiedRecord: { added: false, duplicate: false },
      nextAction: { kind: 'landing_primary', label: 'Continue' },
      secondaryAction: { kind: 'use_locally', label: 'Find nearby offers' },
      sharePayload: {
        entityType: 'task',
        entityId: 'task-preview-011',
        amountUSD: 0,
        amountJGK: 0,
        status: 'task_completed',
      },
    },
  },
];

export const POST_COMPLETION_PREVIEW_SCENARIOS =
  postCompletionPreviewScenarios;

export const POST_COMPLETION_PREVIEW_SCENARIO_NAMES =
  POST_COMPLETION_PREVIEW_SCENARIOS.map((scenario) => scenario.name);

export const DEFAULT_POST_COMPLETION_PREVIEW_SCENARIO_NAME =
  POST_COMPLETION_PREVIEW_SCENARIO_NAMES[0];

export const getPostCompletionPreviewScenario = (scenarioName) =>
  POST_COMPLETION_PREVIEW_SCENARIOS.find(
    (scenario) => scenario.name === scenarioName,
  ) || null;

export const resolvePostCompletionPreviewScenario = (scenarioName) => {
  const requested = String(scenarioName || '').trim();
  const resolved =
    getPostCompletionPreviewScenario(requested) ||
    getPostCompletionPreviewScenario(
      DEFAULT_POST_COMPLETION_PREVIEW_SCENARIO_NAME,
    );

  return {
    requestedScenarioName: requested || null,
    invalidScenarioName: requested && !getPostCompletionPreviewScenario(requested) ? requested : null,
    scenario: resolved,
    validScenarioNames: POST_COMPLETION_PREVIEW_SCENARIO_NAMES,
    defaultScenarioName: DEFAULT_POST_COMPLETION_PREVIEW_SCENARIO_NAME,
  };
};
